module.exports = __webpack_public_path__ + "img/no-sand.fe952e30.svg";